function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";
const expandable = defaultHeight => WrappedComponent => {
  function calculateHeight(expandedHeight) {
    if (expandedHeight) {
      return expandedHeight;
    }
    if (defaultHeight) {
      return defaultHeight;
    }
    return undefined;
  }
  class Expandable extends React.PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
      const expandedHeight = calculateHeight(nextProps.expandedHeight);
      if (expandedHeight !== prevState.expandedHeight) {
        return {
          expandedHeight
        };
      }
      if (!!nextProps.expandedByDefault !== !!prevState.expanded && !prevState.expanderToggled) {
        return {
          expanded: nextProps.expandedByDefault
        };
      }
      return null;
    }
    constructor(props) {
      super(props);
      _defineProperty(this, "onExpandToggle", () => {
        const expanded = this.state.expanded;
        this.setState({
          expanded: !expanded,
          expanderToggled: true
        });
        if (this.props.onExpandToggle) {
          this.props.onExpandToggle(!expanded);
        }
      });
      this.state = {
        expanded: props.expandedByDefault,
        expandedHeight: calculateHeight(props.expandedHeight),
        expanderToggled: false
      };
    }
    componentDidUpdate(prevProps) {
      if (prevProps.expanded !== this.props.expanded) {
        this.setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
          expanded: this.props.expanded
        }));
      }
    }
    render() {
      return ___EmotionJSX(WrappedComponent, _extends({}, _objectSpread(_objectSpread({}, this.props), this.state), {
        onExpandToggle: this.onExpandToggle
      }));
    }
  }
  _defineProperty(Expandable, "defaultProps", {
    expanded: false,
    expandedByDefault: false,
    expandedHeight: undefined,
    onExpandToggle: undefined
  });
  return Expandable;
};
export default expandable;